import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function httpRequest(url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var contentType = headers['Content-Type'] || headers['content-type'] || '';

  if (contentType === 'application/json' && body && typeof body !== 'string') {
    body = JSON.stringify(body);
  }

  return fetch(url, {
    method: method,
    headers: _objectSpread({}, headers),
    body: body // credentials: args.withCredentials === false ? 'omit' : 'include',

  }).then(function (response) {
    var _response$headers, _response$headers$get, _response$headers$get2;

    var error = !response.ok;
    var status = response.status;

    var respHandler = function respHandler(resp) {
      var result = {
        responseText: resp,
        status: status
      }; // TODO: is this the correct way?

      if (error) {
        throw result;
      }

      return result;
    };

    if ((_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : (_response$headers$get = _response$headers.get('Content-Type')) === null || _response$headers$get === void 0 ? void 0 : (_response$headers$get2 = _response$headers$get.toLowerCase()) === null || _response$headers$get2 === void 0 ? void 0 : _response$headers$get2.includes('application/json')) {
      return response.json().then(respHandler);
    } else {
      return response.text().then(respHandler);
    }
  });
}
/**
 * Transforms locale of form xx-xx to ISO format
 * @param locale
 */

export function localeToISO(locale) {
  var providedLocale = locale === 'en' ? 'en-xx' : locale;
  return providedLocale.replace(/[^-]*$/, function (o) {
    return o.toUpperCase();
  });
}
/**
 * Expects an url of form {protocol}://{top level domain}/{locale}/
 * the locale is expected in the form xx-xx. if that's not the case,
 * it will fallback to 'en'
 */

export function getLocaleFromUrl() {
  if (typeof window !== 'undefined' && window.location !== undefined) {
    var path = window.location.pathname;
    var localeArray = /\/([\w]{2})-([\w]{2})\//.exec(path);

    if (localeArray && localeArray.length) {
      return {
        locale: localeArray[0].replace(/\//g, ''),
        language: localeArray[1],
        region: localeArray[2]
      };
    } else {
      return {
        locale: 'en',
        language: 'en',
        region: null
      };
    }
  }

  return {
    locale: 'en-gb',
    language: 'en',
    region: 'gb'
  };
}